export default __webpack_public_path__ + "static/media/profile_picture.0d04b47a.png";